import React from 'react'
import { actions as formActions, Control, getModel } from 'react-redux-form'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'

import withTinyMCE from '../withTinyMCE'

class TinyMCEControl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      config: this.configuration(this.props.id, this.props.config),
      initialValue: this.props.content
    }
  }

  configuration(id, config) {
    const deflt = h2?.getPrivateOptionsTinyMCE?.(`#${id}`)

    console.log(deflt)

    return { plugins: [], ...deflt, ...config }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
    //console.log("TinyMCEControl will update props=", nextProps, "state=", nextState);
    /*
     * Only configure when id changes (or on first render).
     */
    if (this.props.id !== nextProps.id || this.props.config !== nextProps.config) {
      //console.log("Something changed, resetting TinyMCE configuration")
      this.setState({ config: this.configuration(nextState.id, nextState.config) })
    }

    //If render keys have changed we need to reset content
    const { renderKey: currentRenderKey } = this.props
    const { renderKey: nextRenderKey } = nextProps

    if (currentRenderKey !== nextRenderKey) {
      console.log(
        `[${nextProps.id}]`,
        'Render key was',
        currentRenderKey,
        'changed to',
        nextRenderKey
      )
      const { content: newContent = '' } = nextProps
      const editor = tinymce.EditorManager.get(this.props.id)

      if (editor) {
        editor.setContent(newContent)
        editor.selection.select(editor.getBody(), true)
        editor.selection.collapse(false)
      } else {
        console.log(`[${nextProps.id}]`, "No editor found, can't update content")
      }
    }
  }

  /*
   * Calling this too often during typing will lead to excessive validations and much slowness
   */
  debouncedChange = debounce(editor => {
    const text = editor.getContent({ format: 'text' })
    /*
     * We check to see if the contents are empty.  If they are, we validate the empty
     * text rather than the raw html.  Otherwise required can be tripped up by p tags
     */
    const contents =
      text.replace(/\s/g, '') === '' ? text : editor.getContent({ format: 'raw' })

    //console.log(`Dispatching change of`, contents, `for`, this.props.model);
    this.props.dispatch(formActions.change(this.props.model, contents))
  }, 250)

  render() {
    //console.log("TinyMCEControl will render with props=", this.props, "state=", this.state);
    const { config, /* no need to pass config */ ...rest } = this.props

    console.log('SETTINGS', this.state.config)

    return (
      <Control.custom
        component={this.props.TinyMCE}
        initialValue={this.state.initialValue}
        //getValue={ event => event?.target?.getContent() } not used, regular onChange is bypassed
        init={this.state.config || {}}
        onChange={event => {
          //props.onChange?.(event); purposefully bypassed to avoid double updates
          const editor = event.target

          this.debouncedChange(editor)
        }}
        {...rest}>
      </Control.custom>
    )
  }
}

export default withTinyMCE(
  connect((state, ownProps) => {
    const { model } = ownProps
    const content = getModel(state, model)

    //console.log("Retrieved content", content, "from model", model, "props", ownProps);
    return {
      content
    }
  })(TinyMCEControl)
)
